import styled from "@emotion/styled";

export const BellContainer = styled.div<{ $showLabel?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: ${({ $showLabel }) => ($showLabel ? "flex-start" : "center")};
  cursor: pointer;
  padding: ${({ $showLabel, theme }) => ($showLabel ? `${theme.spacing.sm} 0.75rem` : "0.5rem")};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  color: ${({ theme }) => theme.colors.text};
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.surface};
  }
`;

export const UnreadBadge = styled.div`
  position: absolute;
  top: 4px;
  right: 6px;
  background-color: ${({ theme }) => theme.colors.danger};
  color: white;
  font-size: 0.65rem;
  font-weight: bold;
  height: 16px;
  min-width: 16px;
  padding: 0 4px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.background};
`;
